import cx from 'classnames'

import { ReactComponent as TextStyleIcon } from 'assets/icons/textStyle24.svg'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import { MarkButtonProps } from '../Types'

import Styles from '../MobileToolbar.module.scss'

export const TextStyleButton = ({ selected, ...props }: ButtonProps & MarkButtonProps) => {
  return (
    <Button
      variant="none"
      size="sm"
      preventFocusOnPress
      className={cx(Styles.button, {
        [Styles.buttonSelected]: selected,
      })}
      {...props}
    >
      <TextStyleIcon />
    </Button>
  )
}
